@if (messages && messages.size && translatedMessages && translatedMessages.length) {
  <div>
    <ul>
      @for (message of translatedMessages; track message) {
        <li>{{ message }}</li>
      }
    </ul>
  </div>
}
